import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=5d6b0b08&scoped=true&"
import script from "./AddArticle.vue?vue&type=script&lang=js&"
export * from "./AddArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=5d6b0b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b0b08",
  null
  
)

export default component.exports